import { useState } from 'react';

import AddCollaboratorSuccessScreen from './add-collaborator-success-screen';
import CollaboratorDetailsForm from './collaborator-details-form';
import { AddCollaboratorSteps } from '../../../hooks/use-collaborator-details-form';
import { MainWrapper, InnerWrapper } from './add-collaborator-flow.styled';

function AddCollaboratorFlow() {
  const [addCollaboratorStep, setAddCollaboratorStep] = useState(AddCollaboratorSteps.FILL_INFO);

  return (
    <MainWrapper>
      <InnerWrapper>
        {addCollaboratorStep === AddCollaboratorSteps.VIEW_SUCCESS_MESSAGE ? (
          <AddCollaboratorSuccessScreen />
        ) : (
          <CollaboratorDetailsForm step={addCollaboratorStep} setStep={setAddCollaboratorStep} />
        )}
      </InnerWrapper>
    </MainWrapper>
  );
}
export default AddCollaboratorFlow;
